import { useCallback, useEffect } from 'react';

import { EPaymentProvider } from '../../../../contracts';
import { usePaymentState } from '../../hooks/use-payment-state';
import { SavedCardsContainer } from '../SavedCardContainer/SavedCardContainer';
import { useStripeSavedCardSubmit } from './hooks/use-stripe-saved-card-submit';
import { useCheckout } from '../../../../hooks/use-checkout';

interface StripeCardContainerProps {
  onCardFlowChange: (flow: { show: boolean; defaultSavedCardChecked: boolean }) => void;
}

export function StripeCardContainer({ onCardFlowChange }: StripeCardContainerProps) {
  const savedCards = usePaymentState((state) => state.savedCards);
  const { selectedPaymentMethod } = useCheckout();
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);
  const { handleSubmit } = useStripeSavedCardSubmit();

  const onReady = useCallback(() => {
    setIsApmLoading(false);
    setIsPaymentElementLoading(false);
  }, [setIsPaymentElementLoading, setIsApmLoading]);

  const showCardFlow = () => {
    onCardFlowChange({ show: false, defaultSavedCardChecked: true });
  };

  useEffect(() => {
    const hasStripeCards = Boolean(
      savedCards.filter((card) => card.paymentProvider === EPaymentProvider.stripe).length
    );
    onCardFlowChange({ show: hasStripeCards, defaultSavedCardChecked: false });
  }, [selectedPaymentMethod?.id]);

  return (
    <SavedCardsContainer
      onReady={onReady}
      paymentProvider={EPaymentProvider.stripe}
      onPayClicked={handleSubmit}
      showCardFlow={showCardFlow}
      isSecurityCodeRequired={false}
    />
  );
}
